/* Require deliberate plug choices while keeping Shrine's native cart variants. */
(() => {
  if (window.cozyPlugChoiceInitialized) return;
  window.cozyPlugChoiceInitialized = true;
  const initialized = new WeakSet();
  function initialize() {
    document.querySelectorAll('[data-cozy-plug-section]').forEach(panel => {
      if (initialized.has(panel)) return;
      const section = panel.dataset.cozyPlugSection;
      const root = document.getElementById('MainProduct-' + section);
      const picker = document.getElementById('variant-selects-' + section);
      const select = panel.querySelector('[data-cozy-plug-select]');
      const mainButton = document.getElementById('ProductSubmitButton-' + section);
      const stickyButton = document.getElementById('StickyAtcSubmitButton-' + section);
      const form = document.getElementById('product-form-' + section);
      const bundles = document.getElementById('quantity-breaks-' + section);
      if (!root || !picker || !select || !mainButton || !form) return;
      initialized.add(panel);
      // Some colors have no featured_media on their Shopify variants. Use the
      // product's cover for its first color, while honoring assigned color media.
      const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
      const colorIndex = Number(picker.dataset.cozyColorIndex);
      const colorField = picker.querySelector('.cozy-option--color');
      const stickyImage = document.getElementById('sticky-atc-image-' + section);
      function syncColorMedia() {
        if (!colorField || !Number.isInteger(colorIndex)) return;
        const color = colorField.querySelector('input:checked')?.value;
        if (!color) return;
        const assigned = variants.find(variant => variant.options[colorIndex] === color && variant.featured_media?.id);
        const mediaId = assigned?.featured_media?.id ||
          (color === variants[0]?.options[colorIndex] ? picker.dataset.cozyDefaultMedia : null);
        const gallery = document.getElementById('MediaGallery-' + section);
        const target = mediaId && gallery?.querySelector('[data-media-id="' + section + '-' + mediaId + '"]');
        if (stickyImage) {
          const source = assigned?.featured_image?.src ||
            (color === variants[0]?.options[colorIndex] ? stickyImage.dataset.cozyDefaultImage : target?.querySelector('img')?.src);
          if (source && stickyImage.getAttribute('src') !== source) stickyImage.src = source;
        }
        if (target && !target.classList.contains('is-active') && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(section + '-' + mediaId, true);
        }
      }
      picker.addEventListener('change', syncColorMedia);
      // Clicking an already selected color should also return from a manually
      // browsed gallery photo. Read the selection after the label's default action.
      colorField?.addEventListener('click', event => {
        if (event.target.closest('label[for], input[type="radio"]')) queueMicrotask(syncColorMedia);
      });
      const supported = new Set([...select.options].map(option => option.value).filter(Boolean));
      const help = document.getElementById('CozyPlugHelp-' + section);
      const helpText = help?.textContent;
      const rowChoices = new Map();
      let restoring = false;
      const quantity = () => Number(bundles?.querySelector('input[name="quantity"]:checked')?.value || 1);
      const activeOffer = () => bundles?.querySelector('input[name="quantity"]:checked')?.dataset.input;
      const activeRows = () => quantity() > 1 ? [...(bundles?.querySelector('label[data-input="' + activeOffer() + '"]')?.querySelectorAll('.quantity-break__selector-item') || [])] : [];
      const plugField = row => row.querySelector('[data-cozy-bundle-option="Plug Type"]');
      function missingField() {
        if (quantity() === 1) return supported.has(select.value) ? null : select;
        return activeRows().map(plugField).find(field => !field || !supported.has(field.value)) || null;
      }
      function updateGate() {
        panel.hidden = quantity() > 1;
        // Leave stock/loading states to Shrine; validate a missing plug on click.
        if (supported.has(select.value) || panel.hidden) {
          select.removeAttribute('aria-invalid');
          if (help) {
            help.textContent = helpText;
            help.classList.remove('cozy-plug-help--error');
          }
        }
        bundles?.querySelectorAll('[data-cozy-bundle-option="Plug Type"]').forEach(field => {
          if (!supported.has(field.value)) return;
          field.removeAttribute('aria-invalid');
          const error = document.getElementById(field.id + '-error');
          if (error) error.hidden = true;
        });
      }
      function revealChoice(field) {
        // Stay in the original tap so iOS can open its native select. Finish the
        // scroll and resolve the new field position before opening that popup.
        field.scrollIntoView({block: 'center', behavior: 'instant'});
        field.getBoundingClientRect();
        field.focus({preventScroll: true});
        if (typeof field.showPicker === 'function') {
          try { field.showPicker(); }
          catch (_) { /* Native focus remains the fallback where showPicker is unavailable. */ }
        }
      }
      function requestChoice(event) {
        const field = missingField();
        if (!field) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        field.setAttribute('aria-invalid', 'true');
        if (field === select && help) {
          help.textContent = 'Please choose your plug type before adding to cart.';
          help.classList.add('cozy-plug-help--error');
        } else {
          let error = document.getElementById(field.id + '-error');
          if (!error) {
            error = document.createElement('p');
            error.id = field.id + '-error';
            error.className = 'cozy-plug-error';
            error.setAttribute('role', 'alert');
            field.closest('.quantity-break__selector-item').append(error);
            field.setAttribute('aria-describedby', error.id);
          }
          error.textContent = 'Please choose a plug for this blanket.';
          error.hidden = false;
        }
        revealChoice(field);
      }
      document.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (button === mainButton || button === stickyButton) requestChoice(event);
      }, true);
      form.addEventListener('submit', requestChoice, true);
      select.addEventListener('change', () => {
        if (!supported.has(select.value)) { updateGate(); return; }
        const native = [...picker.querySelectorAll('input[type="radio"]')].find(input => input.name === panel.dataset.optionName && input.value === select.value);
        if (!native) return;
        select.removeAttribute('aria-invalid');
        native.checked = true;
        native.dispatchEvent(new Event('change', {bubbles: true}));
        updateGate();
      });
      // Each offer retains its own explicit choices. A main color update must not
      // silently replace the plugs/colors a customer already chose per blanket.
      bundles?.querySelectorAll('.quantity-break__selector-item').forEach(row => {
        rowChoices.set(row, [...row.querySelectorAll('select')].map(field => field.value));
      });
      bundles?.addEventListener('change', event => {
        const row = event.target.closest('.quantity-break__selector-item');
        if (!row || restoring) return;
        rowChoices.set(row, [...row.querySelectorAll('select')].map(field => field.value));
        if (supported.has(plugField(row)?.value)) plugField(row).removeAttribute('aria-invalid');
        else {
          // Shrine would otherwise fall back to a default variant for an empty plug.
          event.stopImmediatePropagation();
        }
        updateGate();
      }, true);
      root.addEventListener('change', updateGate);
      if (bundles) {
        const bundleObserver = new MutationObserver(() => {
          bundleObserver.disconnect();
          restoring = true;
          for (const [row, values] of rowChoices) {
            row.querySelectorAll('select').forEach((field, index) => {
              if (field.dataset.cozyBundleOption === 'Plug Type' && ![...field.options].some(option => option.value === '')) {
                const placeholder = new Option('Choose a plug', '', false, false);
                placeholder.disabled = true;
                field.prepend(placeholder);
              }
              field.value = values[index];
            });
            if (supported.has(plugField(row)?.value)) bundles.handleSelectChange({currentTarget: row});
          }
          // renderProductInfo resets formVariants; restore the active offer last.
          if (activeOffer()) bundles.updateFormVariants(activeOffer());
          restoring = false;
          bundleObserver.observe(bundles, {childList: true, subtree: true});
          updateGate();
        });
        bundleObserver.observe(bundles, {childList: true, subtree: true});
      }
      updateGate();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
